<div class="component-container">
  <div
    class="row w-full flex xs:flex-col sm:flex-col md:flex-row space md:space-x-[1rem] xs:space-x-0 xs:justify-center sm:space-x-0 sm:justify-center items-center">
    <div
      class="flex flex-row xs:w-full sm:w-full md:w-[45%] space-x-[1rem]">
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['status']"
        [options]="statusFilterList"
        [parentFormGroup]="form"
        class="input w-[100%]"
        controlName="status"
        label="Status"
        placeholder="Select one"
        type="small"
      />
    </div>

    <div class="vertical hidden md:block"></div>

    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      (handleSuffixClick)="apply()"
      [error]="errorMessages['searchText']"
      [parentFormGroup]="form"
      class="input xs:w-full sm:w-full md:w-[45%] search-input"
      controlName="searchText"
      label="Search Measurement Name"
      placeholder="Search measurement name..."
      suffixIcon="search"
      type="small"
    ></app-text-input>

    <div class="vertical hidden md:block"></div>

    <app-primary-button
      (handleClick)="apply()"
      class="btn xs:w-full sm:w-full md:w-[30%] xs:mb-[2rem] md:mb-0"
      type="small"
    >
      Apply
    </app-primary-button>
  </div>
</div>
